import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import AgentsTable from "components/agents/AgentsTable";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import AgentsServices from "services/AgentsServices";
import AgentsDrawer from "components/drawer/AgentsDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { SidebarContext } from "context/SidebarContext";
import { FiPlus } from "react-icons/fi";
import { Tabs, Tab } from "@mui/material";
import sidebar from "routes/sidebar";
import DataWrapper from "./DataWrapper";
import { FiRefreshCcw } from "react-icons/fi";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import socket from "services/SocketService";

const Agents = () => {
  const location = useLocation();
  // const { loading, data, error } = useAsync(AgentsServices.getAllAgents);
  const { toggleDrawer, isUpdate, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tab, setTab] = useState(0);
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const isAdmin = adminInfo?.id === 1;
  const allowAccess =
    isAdmin ||
    adminInfo?.permission?.some(
      (p) => p.id_tab === "agent list" && p.edit === 1,
    );

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "agent list" && perm.view === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "agent list" && perm.edit === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "agent list" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "agent list" && perm.export === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "agent list" && perm.delete === 1,
      );

  // const [agentsData, setAgentsData] = useState([]);
  const [agentsData, setAgentsData] = useState({
    status: false,
    data: [],
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [agentStatusParam, setAgentStatusParam] = useState(null);

  const isDataArray = Array.isArray(agentsData?.data); // Check if data is an array
  const safeData = isDataArray ? agentsData?.data : []; // Use empty array if data is not an array
  // console.log("data from safedata", safeData);

  const filteredAgentsData = safeData;

  const { agentsRef, serviceData, dataTable, handleSubmitAgents, currentPage } =
    useFilter(filteredAgentsData, itemsPerPage);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("agentstatus");
    if (status !== null) {
      setTab(status === "Inactive" ? 1 : 0);
      setAgentStatusParam(status);
      return;
    }

    // setAgentStatusParam(null);
  }, [location.search]);

  useEffect(() => {
    if (agentsData?.status) {
      setStatus(agentsData.status);
    } else {
      setStatus(false);
    }
  }, [agentsData?.status]);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);
  const updatedData = safeData.map((item, index) => {
    // console.log("data in updatedata", item);

    return {
      "SI.No": index + 1,
      "Agent ID": item.reference_no,
      Account: item.account_info,
      // "Added Date": item.added_date,
      "Added Date": item.added_date
        ? new Date(item.added_date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : "",
      "Company Name": item.company_name,
      // "Name Title": item.name_title,
      // "Contact Person": item.name,

   "Contact Person": [item.name_title, item.name].filter(Boolean).join(" "),
      Email: item.email_id,
      "Contact Number": item.mobile_no,
      "Alternative Number": item.al_mobile_no || "-",
      "Gst No": item.gst_no || "-",
      "Agent Type": item.agent_type,
      Country: item.country_name,
      State: item.state_name,
      City: item.city_name,
      Address: item.address,
      "Company Type": item.company_type,
    };
  });
  const fetchAgents = async () => {
    setLoading(true);
    setError("");
    try {
      if (location.search && agentStatusParam === null) return;
      let response;

      const payload = {
        is_seller: adminInfo?.profile === "Sales",
        id: adminInfo?.id, // seller’s own ID
        in_activeagents: agentStatusParam,
      };

      // Non-admins can only see tab 1 data
      if (!allowAccess) {
        response = await AgentsServices.getAllAgents(2, payload); // Activate Agents only
        setTab(1); // Ensure always stays on tab 1
      } else {
        // Admin can view all
        if (tab === 0) {
          response = await AgentsServices.getAllAgents(1, payload);
        } else if (tab === 1) {
          response = await AgentsServices.getAllAgents(2, payload);
        } else if (tab === 2) {
          response = await AgentsServices.getAllAgents(3, payload);
        }
      }

      if (response) {
        setAgentsData(response);
      } else {
        console.error("No agents data found.");
      }
    } catch (err) {
      // catch (error) {
      //   console.error("Error fetching agents data:", error);
      // }

      console.error("Error fetching agents:", err);
      setError(err.message || "Something went wrong.");
      setAgentsData({
        status: false,
        data: [],
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgents();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate]);

  // Live online/offline status: the socket server pushes this the moment an
  // agent or sub-user actually logs in/out, instead of waiting for a refresh.
  useEffect(() => {
    const handleAgentStatusUpdate = ({ agent_id, login_status }) => {
      console.log("[agent_status_update] RECEIVED on Agents page:", {
        agent_id,
        login_status,
      });
      if (!agent_id) {
        console.log(
          "[agent_status_update] NOT APPLIED: no agent_id in payload",
        );
        return;
      }
      setAgentsData((prev) => {
        if (!Array.isArray(prev?.data)) {
          console.log(
            "[agent_status_update] NOT APPLIED: agents list not loaded yet",
          );
          return prev;
        }
        const matched = prev.data.some(
          (row) => Number(row.id) === Number(agent_id),
        );
        console.log(
          matched
            ? `[agent_status_update] APPLIED: agent ${agent_id} -> login_status=${login_status}`
            : `[agent_status_update] NOT APPLIED: agent ${agent_id} not found in current list (wrong tab/filter?)`,
        );
        return {
          ...prev,
          data: prev.data.map((row) =>
            Number(row.id) === Number(agent_id)
              ? { ...row, login_status, is_online: login_status === 1 }
              : row,
          ),
        };
      });
    };

    socket.on("agent_status_update", handleAgentStatusUpdate);
    return () => socket.off("agent_status_update", handleAgentStatusUpdate);
  }, []);
  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleRefresh = () => {
    setIsUpdate(true);
  };

  const getTabName = () => {
    if (tab === 0) return "Unverified";
    if (tab === 1) return "Activate";
    if (tab === 2) return "Rejected";
    return "";
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <AgentsDrawer id={serviceId} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="gap-6 flex items-center">
                <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
                  <Input
                    ref={agentsRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    autoComplete="off"
                    name="search"
                    placeholder="Quick Search"
                    onChange={handleSubmitAgents}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Agents
                  </Button>
                )}

                {hideExport && (
                  <div className="items-center">
                    <ExportDataXlsx
                      title="Agents"
                      exportDataXlsx={updatedData}
                      fileNames={`Agents_${getTabName()}`}
                    />
                  </div>
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>

          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            {allowAccess && (
              <Tab
                className="focus:outline-none dark:text-white"
                sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
                label="Unverified"
              />
            )}
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Activate Agents"
            />
            {allowAccess && (
              <Tab
                className="focus:outline-none dark:text-white"
                sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
                label="Rejected Agents"
              />
            )}
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData.length > 0 ? (
              <TableContainer
                className="mb-4"
                style={{
                  maxHeight: "65vh",
                  overflow: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell className="text-center">Sl.No.</TableCell>
                      <TableCell className="text-center">Agent ID</TableCell>
                      <TableCell className="text-center">Added Date</TableCell>
                      <TableCell className="text-center">
                        Company Name
                      </TableCell>
                      <TableCell className="text-center">
                        Contact Person
                      </TableCell>
                      <TableCell className="text-center">Type </TableCell>
                      {/* <TableCell className="text-center">Email </TableCell> */}
                      {tab === 0 && (
                        <TableCell className="text-center">New/Edit </TableCell>
                      )}
                      {(tab === 1 || tab === 0) && (
                        <TableCell className="text-center">Status </TableCell>
                      )}
                      {tab === 1 && (
                        <TableCell className="text-center">
                          Login Status
                        </TableCell>
                      )}
                      {tab === 1 && hideView && (
                        <TableCell className="text-center"> Remarks </TableCell>
                      )}
                      <TableCell className="text-center">Actions</TableCell>
                    </tr>
                  </TableHeader>
                  <AgentsTable
                    agents={dataTable}
                    perpage={itemsPerPage}
                    currentPage={currentPage}
                    tab={tab}
                    hideEdit={hideEdit}
                    fetchAgents={fetchAgents}
                    isAdmin={isAdmin}
                    allowAccess={allowAccess}
                    hideView={hideView}
                    hideDelete={hideDelete}
                  />
                </Table>
              </TableContainer>
            ) : (
              // Show NotFound if there is no data
              <>
                {agentsData.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Agents." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Agents;
